import type {
  ConversationStartersContext,
  TellentAssistantAppContext,
} from '@core/tellent-assistant-types';

export function toStartersContext(ctx: TellentAssistantAppContext): ConversationStartersContext {
  const entity = ctx.entities.at(-1);
  switch (entity?.type) {
    case 'candidate':
      return {
        type: 'recruitment_candidate',
        params: { candidateId: entity.id, candidateName: entity.name },
      };
    case 'job':
      return { type: 'recruitment_job', params: { jobId: entity.id, jobTitle: entity.title } };
    case 'analytics_dashboard':
      return {
        type: 'recruitment_analytics',
        params: { dashboardId: entity.id, dashboardName: entity.name },
      };
    default:
      return { type: 'recruitment_general' };
  }
}
